import { BookOpen, MessageCircleQuestion, PenLine } from "lucide-react";
import { Reveal } from "./Reveal";

const BLOCKS = [
  {
    icon: BookOpen,
    title: "Propracované principy",
    text: "Každý princip je rozebraný do hloubky a zasazený do konkrétních situací, které možná znáš i ty.",
  },
  {
    icon: PenLine,
    title: "Praktické úkoly",
    text: "Nezůstaneš jen u teorie. Kniha obsahuje praktické podněty a cvičení, která lze převést do života.",
  },
  {
    icon: MessageCircleQuestion,
    title: "Otázky k zamyšlení",
    text: "Otázky ti pomůžou vztáhnout jednotlivé principy na vlastní život — ne na život někoho jiného.",
  },
];

export const InsideBook = () => (
  <section className="bg-cream py-28 text-navy-deep sm:py-36" data-testid="inside-book-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="mb-6 flex items-center gap-4 text-xs font-semibold uppercase tracking-[0.3em] text-bronze">
          <span className="h-px w-10 bg-bronze/60" aria-hidden="true" />
          Podívej se dovnitř e-booku
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="max-w-3xl font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
          Jak je každý princip <span className="italic text-bronze">postavený</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8">
        {BLOCKS.map((b, i) => (
          <Reveal key={b.title} delay={0.08 * i}>
            <div className="border-t-2 border-bronze/40 pt-8">
              <b.icon className="h-7 w-7 text-bronze" strokeWidth={1.5} aria-hidden="true" />
              <h3 className="mt-6 font-serif text-2xl font-medium uppercase tracking-wide">
                {b.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-navy-deep/70">{b.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-24 text-center font-serif text-3xl font-medium italic leading-snug text-navy-deep sm:text-4xl lg:text-5xl">
          „Nejen číst. Přemýšlet.
          <br />
          A hlavně – <span className="text-bronze">jednat</span>.“
        </p>
      </Reveal>
    </div>
  </section>
);
